import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  pushClickBreadcrumb,
  pushRouteBreadcrumb,
} from '../utils/diagnostics/breadcrumbBuffer';

function describeTarget(target) {
  if (!target || target.nodeType !== 1) return null;
  const trigger = target.closest('button, a, [role="button"], [role="link"]');
  if (!trigger) return null;
  const tag = trigger.tagName.toLowerCase();
  const role = trigger.getAttribute('role') || tag;
  const ariaLabel = trigger.getAttribute('aria-label');
  const textLabel = trigger.textContent ? trigger.textContent.trim().slice(0, 80) : '';
  const label = ariaLabel || textLabel || trigger.getAttribute('title') || '';
  return { tag, role, label };
}

function BreadcrumbProvider({ children }) {
  const { pathname, search } = useLocation();
  const previousPath = useRef(null);

  useEffect(() => {
    const path = `${pathname}${search}`;
    if (previousPath.current !== path) {
      pushRouteBreadcrumb({ from: previousPath.current || '', to: path });
      previousPath.current = path;
    }
  }, [pathname, search]);

  useEffect(() => {
    const handler = (event) => {
      const target = event.target;
      if (target?.closest?.('[data-issue-reporter]')) return;
      const described = describeTarget(target);
      if (described) pushClickBreadcrumb(described);
    };
    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
  }, []);

  return children;
}

export default BreadcrumbProvider;
